import { createI18n } from 'vue-i18n'
import { arrayToMap } from '@/utils/index'
import store from '../store/index'

import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import zhCN from './lang/zh-CN.json'
import jaJP from './lang/ja-JP.json'
import enUS from './lang/en-US.json'

export const localeList = [
  { name: '简体中文', value: 'zh-CN', lang: zhCN },
  { name: '日本語', value: 'ja-JP', lang: jaJP },
  { name: 'English', value: 'en-US', lang: enUS },
]
export const localeNames = arrayToMap(localeList, 'value', 'name')
export const localeMessages = arrayToMap(localeList, 'value', 'lang')

const i18n = createI18n({
  messages: localeMessages,
  legacy: false,
  locale: window.localStorage.getItem("lang") || 'zh-CN'
})

export async function setI18nLang(locale) {
  console.log('setI18nLang', locale)
  i18n.global.locale.value = locale
  dayjs.locale(locale)
  store.commit('setLocale', locale)
  // axios.defaults.headers.common['Accept-Language'] = locale
  // document.querySelector('html').setAttribute('lang', locale)
}

export default i18n
